import React from 'react';
import { useParams } from 'react-router-dom';

import Brand from '../../components/Brand';
import FormPrimeiroAcesso from '../../components/FormPrimeiroAcesso';
import { BackgroundLogin, ContainerLogin, WrapperForm } from './styles';

function PrimeiroAcesso() {
  const { token } = useParams();
  return (
    <BackgroundLogin type="flex" align="middle" justify="center">
      <ContainerLogin>
        <Brand />
        <WrapperForm>
          <FormPrimeiroAcesso token={token} />
        </WrapperForm>
      </ContainerLogin>
    </BackgroundLogin>
  );
}
export default PrimeiroAcesso;
